import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'

import { cn } from '../lib/cn'
import { popoverSurface } from '../lib/surfaces'

// The label of a control that shows none. It exists for the collapsed nav rail, where the
// icon is all there is: why that is not decoration, packages/ui/docs/nessuna-stringa-qui-dentro.md.

/** Wraps the app once, so every tooltip shares one delay and one open-at-a-time behaviour. */
export function TooltipProvider({ children }: { children: React.ReactNode }) {
  return <TooltipPrimitive.Provider delayDuration={300}>{children}</TooltipPrimitive.Provider>
}

export const Tooltip = TooltipPrimitive.Root
export const TooltipTrigger = TooltipPrimitive.Trigger

export type TooltipContentProps = React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>

/** The bubble. `sideOffset` clears the trigger; the arrow is deliberately absent — at this
 *  size it is three pixels of noise. */
export const TooltipContent = React.forwardRef<
  React.ComponentRef<typeof TooltipPrimitive.Content>,
  TooltipContentProps
>(({ className, sideOffset = 6, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      data-surface="ink"
      className={cn(
        popoverSurface,
        'bg-background px-2 py-1 text-xs font-medium text-foreground',
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = 'TooltipContent'
